<template>
    <div ref="subTable" class="crosstab-title">
        <h2>
            <div style="text-align: center">
                Behavioral Risk Factor Surveillance System
            </div>
            <div>Cross Tabulation, {{ locations }}, {{ years }}</div>
            <div>{{ getRowsAndColumns(reportModel) }}</div>
        </h2>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import commonModelHelper from '@/scripts/commonModelHelper';
import store from '@/store';

export default {
    props: ['reportModel'],
    data: function () {
        var vm = this;
        return {
            locations: commonModelHelper.getReportTitleLocations(
                store.state.selModel.locations
            ),
            years: commonModelHelper.getDisplayYearsWithAnd()
        };
    },
    methods: {
        getRowsAndColumns
    }
};

function getRowsAndColumns(reportModel) {
    var vm = this;
    if (!reportModel || !reportModel.parms) return '';
    return (
        ' of ' +
        reportModel.parms.row.groupToString() +
        (vm.reportModel.parms.column === null
            ? ''
            : ' by ' + vm.reportModel.parms.column.groupToString())
    );
}
</script>

<style scoped>
h2 {
    display: block;
    font-size: 22px;
    -webkit-margin-before: 0.67em;
    margin-block-start: 0.67em;
    -webkit-margin-after: 0.67em;
    margin-block-end: 0.67em;
    -webkit-margin-start: 0px;
    margin-inline-start: 0px;
    -webkit-margin-end: 0px;
    margin-inline-end: 0px;
    font-weight: 400;
    color: black;
    background-color: inherit;
}

h2 {
    text-align: center;
    margin: 0 0 0 0;
}

h2 div.row {
    font-size: 18px;
    line-height: 24px;
    vertical-align: middle;
}

.crosstab-title {
}

.controlling-for span {
    font-size: 16px;
    line-height: 21px;
}
</style>
